/**
 * Members Translations Module (French)
 * Matches English structure exactly
 * @module members
 * @language fr
 */

export const members = {
  memberInsights: {
    title: "Perspectives des Membres JCI",
    subtitle: "Comprendre démographie, motivations et compétences membres",
    demographics: "Démographie des Membres",
    motivations: "Motivations et Valeurs",
    skills: "Inventaire de Compétences",
    ageDistribution: "Répartition par Âge",
    genderBreakdown: "Répartition par Sexe",
    educationLevel: "Niveau d'Éducation",
    employmentStatus: "Statut d'Emploi",
    regionalDemographics: "Démographie Régionale",
    memberMotivations: "Pourquoi les membres rejoignent JCI?",
    topMotivations: "Principales Motivations",
    personalDevelopment: "Développement Personnel",
    networking: "Réseautage et Connexions",
    communityImpact: "Impact Communautaire",
    leadershipSkills: "Développement Compétences Leadership",
    careerAdvancement: "Avancement Professionnel",
    globalCitizenship: "Citoyenneté Mondiale",
    motivationsByRegion: "Motivations par Région",
    memberSkillsMap: "Carte Compétences Membres",
    topSkills: "Principales Compétences",
    projectManagement: "Gestion de Projet",
    publicSpeaking: "Prise de Parole en Public",
    fundraising: "Levée de Fonds",
    digitalMarketing: "Marketing Numérique",
    eventPlanning: "Planification d'Événements",
    dataAnalysis: "Analyse de Données",
    skillsByCareerStage: "Compétences par Étape de Carrière",
    earlyCareer: "Début Carrière (0-3 ans)",
    midCareer: "Milieu Carrière (4-7 ans)",
    experiencedProfessional: "Professionnel Expérimenté (8+ ans)",
    skillsDevelopmentPriorities: "Priorités Développement Compétences",
    skillsCurrentlyHave: "Compétences que J'ai",
    skillsWantToDevelop: "Compétences que Je Veux Développer",
    skillGap: "Écart de Compétences",
    trainingOpportunities: "Opportunités de Formation",
    memberTestimonials: "Témoignages de Membres",
    readMore: "Lire plus",
    testimonialsList: "Liste de Témoignages",
    surveyMethodology: "Méthodologie Enquête",
    sampleSize: "Taille Échantillon",
    responseRate: "Taux de Réponse",
    surveyPeriod: "Période Enquête",
    dataCollection: "Collecte de Données"
  },
  memberProfile: {
    title: "Profil des Membres JCI",
    surveyInfo: "Enquête sur l'Expérience des Membres 2025 • {{count}} répondants de toutes les régions",
    averageAge: "Âge Moyen",
    ageRange: "Tranche: 18-40",
    universityEducated: "Éducation Universitaire",
    degreesHeldPursuing: "Diplômes obtenus ou en cours",
    entrepreneurs: "Entrepreneurs",
    selfEmployedMembers: "Membres indépendants",
    surveyRespondents: "Répondants à l'Enquête",
    allAreas: "Toutes les 4 Zones JCI",
    ageGroupAnalysis: "Analyse par Groupe d'Âge",
    coreAgeGroup: "Cœur 28-40 ans:",
    years: "ans",
    ofMembers: "des membres",
    challenges: "Défis",
    strengths: "Forces",
    careerEntry: "Entrée en Carrière",
    financialIndependence: "Indépendance Financière",
    educationBalance: "Équilibre Éducatif",
    digitalNative: "Digital Native",
    freshPerspective: "Perspective Nouvelle",
    enthusiasm: "Enthousiasme",
    avgAgeByRegion: "Âge Moyen par Région",
    africaMe: "Afrique et Moyen-Orient",
    asiaPacific: "Asie et le Pacifique",
    americas: "Amérique",
    europe: "Europe",
    youngest: "Le Plus Jeune",
    oldest: "Le Plus Âgé"
  },
  memberExperience: {
    title: "Tableau de Bord de l'Expérience des Membres",
    subtitle: "Métriques de satisfaction et d'engagement des membres",
    npsTitle: "Net Promoter Score",
    npsBreakdown: "Répartition NPS",
    tenureAnalysis: "Analyse de l'Ancienneté",
    tenureInsight: "Aperçu: 53% de nouveaux membres (1-3 ans) apportent une énergie nouvelle tandis que 24% de vétérans (7+ ans) fournissent un leadership et une stabilité essentiels"
  },
  alumni: {
    title: "Réseau des Anciens",
    subtitle: "Continuité générationnelle par le mentorat",
    alumniClubs: "Clubs d'Anciens",
    nations: "Nations",
    avgStay: "Séjour Moyen",
    transitionNote: "Transition aux Anciens à 40+ ans",
    leadershipProgression: "Progression de Leadership",
    majority: "Majorité",
    localChapterLeaders: "Leaders d'Organisations Locales",
    foundationOfJCI: "Fondation de JCI"
  },
  education: {
    title: "Niveau d'Éducation",
    bachelorsDegree: "Licence",
    mastersDegree: "Master",
    mastersEnrolled: "Master (Inscrit)",
    phdPursuing: "Doctorat en Cours",
    technicalVocational: "Technique/Professionnel",
    universityDegreeNote: "97%+ des membres JCI détiennent ou poursuivent des diplômes universitaires"
  },
  industry: {
    title: "Diversité des Industries",
    subtitle: "Principaux secteurs représentés par les membres JCI",
    education: "Éducation",
    technology: "Technologie",
    finance: "Finance",
    healthcare: "Santé",
    nonprofit: "Sans But Lucratif",
    government: "Gouvernement",
    manufacturing: "Industrie",
    services: "Services"
  },
  motivations: {
    title: "Motivations et Valeurs des Membres",
    subtitle: "Ce qui motive l'engagement des membres JCI",
    benefitsTitle: "Motivations et Avantages des Membres",
    benefitsSubtitle: "Comprendre ce qui motive l'engagement des membres JCI",
    source: "Source",
    memberExperienceSurvey: "Enquête sur l'Expérience des Membres",
    whyMembersJoin: "Pourquoi les Membres Rejoignent JCI",
    personalDevelopment: "Développement Personnel",
    growthThroughExperience: "Croissance par l'expérience et les projets",
    leadershipOpportunities: "Opportunités de Leadership",
    accessToRoles: "Accès aux rôles et postes de leadership",
    professionalNetworking: "Réseautage Professionnel",
    buildingConnections: "Développer des connexions professionnelles",
    communityService: "Service Communautaire",
    positiveImpact: "Créer un impact positif dans les communautés",
    mostValuedBenefits: "Avantages les Plus Valorisés",
    leadershipDevelopment: "Développement du Leadership",
    structuredPrograms: "Programmes de développement structurés",
    accessToTraining: "Accès à la Formation et Certifications",
    professionalWorkshops: "Ateliers et cours professionnels",
    globalNetworkConnections: "Réseau Mondial et Connexions",
    connectionsAcrossRegions: "Connexions à travers les régions et les pays",
    impactOpportunities: "Opportunités d'Impact",
    meaningfulChange: "Opportunités de créer un changement significatif"
  },
  skills: {
    title: "Compétences Prioritaires à Développer",
    subtitle: "Classées par niveau d'intérêt des membres",
    source: "Source: Enquête sur l'Expérience des Membres JCI 2025",
    communicationPublicSpeaking: "Communication et Prise de Parole",
    priority: "Priorité",
    publicSpeakingPrograms: "Programmes de prise de parole et débat",
    viewPrograms: "Voir les Programmes",
    associatedPrograms: "Programmes Associés",
    publicSpeakingCompetition: "Concours de Prise de Parole",
    participants: "participants",
    debatingChampionship: "Championnat de Débat",
    teams: "équipes",
    viewProgramsEvents: "Voir Programmes et Événements"
  },
  keyInsights: {
    title: "Principales Conclusions de l'Enquête sur l'Expérience des Membres 2025",
    memberPriorities: "Priorités des Membres",
    memberPriority1: "La croissance personnelle est la motivation principale (28%)",
    memberPriority2: "Le développement du leadership stimule l'engagement (24%)",
    memberPriority3: "Accent fort sur le réseautage et les connexions (21%)",
    memberPriority4: "L'engagement pour le service communautaire reste essentiel (17%)",
    valueProposition: "Proposition de Valeur",
    valueProp1: "JCI répond aux attentes de développement du leadership",
    valueProp2: "Les programmes de formation sont très valorisés (24%)",
    valueProp3: "L'accès au réseau mondial est un différenciateur clé",
    valueProp4: "Les membres recherchent des opportunités d'impact tangible"
  },
  demographics: {
    title: "Démographie des Membres",
    subtitle: "Analyse complète composition membres JCI",
    ageRange: "Tranche d'Âge",
    years: "ans",
    averageAge: "Âge Moyen",
    male: "Masculin",
    female: "Féminin",
    nonBinary: "Non Binaire",
    preferNotToSay: "Préfère ne pas Dire",
    highSchool: "Secondaire",
    bachelors: "Licence",
    masters: "Master",
    doctorate: "Doctorat",
    fullTime: "Temps Plein",
    partTime: "Temps Partiel",
    selfEmployed: "Indépendant",
    student: "Étudiant",
    unemployed: "Sans Emploi",
    sector: "Secteur",
    sectorBreakdown: "Répartition par Secteur",
    privateSector: "Secteur Privé",
    publicSector: "Secteur Public",
    nonprofit: "Sans But Lucratif",
    education: "Éducation",
    healthcare: "Santé",
    technology: "Technologie",
    finance: "Finance",
    other: "Autre",
    tenure: "Ancienneté",
    membershipDuration: "Durée d'Adhésion",
    lessThan1Year: "Moins de 1 An",
    years1to3: "1-3 Ans",
    years4to6: "4-6 Ans",
    years7to9: "7-9 Ans",
    moreThan10Years: "Plus de 10 Ans",
    regionalVariation: "Variation Régionale",
    compareRegions: "Comparer Régions",
    demographicTrends: "Tendances Démographiques",
    trendsOver5Years: "Tendances 5 Dernières Années",
    diversityMetrics: "Métriques de Diversité",
    inclusionScore: "Score d'Inclusion",
    genderBalance: "Équilibre des Sexes",
    ageDistributionHealth: "Santé Répartition par Âge",
    regionalRepresentation: "Représentation Régionale",
    regionalMemberDistribution: "Distribution Régionale des Membres",
    clickToExplore: "Cliquez sur une région pour explorer les détails"
  },
  motivationsPage: {
    title: "Pourquoi JCI?",
    subtitle: "Comprendre motivations membres et moteurs engagement",
    primaryMotivations: "Motivations Primaires",
    whyMembersJoin: "Pourquoi Membres Rejoignent",
    personalGrowth: "Croissance Personnelle",
    developSkills: "Développer nouvelles compétences et capacités",
    expandNetwork: "Étendre réseau professionnel et social",
    makeImpact: "Faire une différence positive",
    leadershipExperience: "Acquérir expérience leadership",
    globalConnection: "Se connecter avec leaders mondiaux",
    motivationsByAge: "Motivations par Âge",
    motivationsByRegion: "Motivations par Région",
    motivationsByTenure: "Motivations par Ancienneté",
    engagementDrivers: "Moteurs d'Engagement",
    whatKeepsMembersActive: "Ce qui Maintient Membres Actifs",
    qualityOfPrograms: "Qualité des Programmes",
    communityBelonging: "Sentiment d'Appartenance",
    leadershipOpportunities: "Opportunités de Leadership",
    networkingEvents: "Événements de Réseautage",
    impactfulProjects: "Projets Impactants",
    personalRecognition: "Reconnaissance Personnelle",
    retentionFactors: "Facteurs de Rétention",
    topReasons: "Principales Raisons de Rester",
    atRiskFactors: "Facteurs de Risque (Pourquoi Membres Partent)",
    timeCommitment: "Engagement Temps Trop Élevé",
    lackOfRelevance: "Manque de Pertinence Carrière",
    poorLeadership: "Leadership Organisation Locale Faible",
    limitedImpact: "Projets Impact Limité",
    memberValueProposition: "Proposition de Valeur Membres",
    perceivedBenefits: "Avantages Perçus",
    skillDevelopment: "Développement Compétences",
    networkExpansion: "Expansion Réseau",
    communityImpact: "Impact Communautaire",
    personalFulfillment: "Accomplissement Personnel",
    careerAdvancement: "Avancement Professionnel",
    costVsBenefit: "Coût vs Avantage",
    membershipFee: "Cotisation",
    timeInvestment: "Investissement Temps",
    perceivedValue: "Valeur Perçue",
    roi: "Retour sur Investissement",
    recommendationLikelihood: "Probabilité Recommandation",
    npsScore: "Score NPS",
    wouldRecommend: "Recommanderait JCI",
    neutral: "Neutre",
    wouldNotRecommend: "Ne Recommanderait pas JCI",
    improvementAreas: "Domaines Amélioration",
    memberSuggestions: "Suggestions Membres",
    moreSkillsTraining: "Plus Formation Compétences",
    betterNetworking: "Meilleures Opportunités Réseautage",
    clearerImpact: "Mesure Impact Plus Claire",
    flexibleCommitment: "Options Engagement Flexible",
    strongerGlobalConnection: "Connexions Mondiales Plus Fortes"
  },
  skillsDevelopment: {
    title: "Tableau de Bord du Développement des Compétences",
    headline: "Former 1 969+ Leaders Annuellement",
    heroDescription: "Développer des leaders est au cœur de la mission de JCI. En 2024-2025, JCI a dispensé une formation de classe mondiale dans quatre domaines d'opportunité, touchant près de 2 000 membres.",
    totalParticipants: "Total des Participants Formés",
    members: "membres",
    leadershipSessions: "Sessions de Formation au Leadership",
    globally: "globalement",
    skillsSessions: "Sessions de Développement des Compétences",
    totalSessions: "Total des Sessions",
    certifiedTrainers: "Réseau de Formateurs Certifiés",
    activeTrainers: "formateurs actifs",
    certifiedTrainersByRegion: "Formateurs Certifiés par Région",
    region: "Région",
    trainers: "Formateurs Certifiés",
    percentGlobal: "% du Global",
    trainingMultiplier: "Multiplicateur de Formation",
    asiaPacific: "Asie et le Pacifique",
    africaMiddleEast: "Afrique et Moyen-Orient",
    americas: "Amérique",
    europe: "Europe",
    highestCapacity: "Capacité la plus élevée",
    rapidGrowth: "Croissance rapide",
    establishedNetwork: "Réseau établi",
    steadyPresence: "Présence stable",
    cascadingKnowledge: "Chaque formateur peut certifier 5-10 formateurs supplémentaires",
    specializedTracks: "Pistes de Formation Spécialisées",
    publicSpeakingTrack: "Prise de Parole et Communication",
    debatingTrack: "Débat et Pensée Critique",
    trainerCertification: "Programme de Certification des Formateurs",
    conferenceTraining: "Profondeur de Formation par Conférence (2025)",
    conference: "Conférence",
    location: "Lieu",
    participants: "Participants",
    sessions: "Sessions",
    regionalReach: "Portée Régionale",
    skillsCategories: "Catégories de Compétences Couvertes",
    leadershipDecision: "Leadership et Prise de Décision",
    communicationInfluence: "Communication et Influence",
    entrepreneurshipInnovation: "Entrepreneuriat et Innovation",
    projectManagement: "Gestion de Projet et Exécution",
    civicResponsibility: "Responsabilité Civique et Citoyenneté Mondiale",
    memberProgression: "Parcours de Progression du Membre",
    stage1: "Étape 1: Participant",
    stage2: "Étape 2: Praticien",
    stage3: "Étape 3: Formateur Certifié",
    stage4: "Étape 4: Formateur Master/Mentor",
    ctaTitle: "Investissez dans Votre Parcours de Leadership",
    exploreTrainings: "Explorer les Formations Disponibles",
    becomeCertified: "Devenir Formateur Certifié",
    sourceNote: "Source: Rapport d'Impact JCI 2025 – Données de Développement des Compétences"
  },
  jciFoundation: {
    title: "Programme de Subventions de la Fondation JCI",
    headline: "100K$+ Annuellement: Financer l'Innovation des Membres",
    heroDescription: "La Fondation JCI représente plus que la collecte de fonds—c'est un engagement à démocratiser les opportunités de leadership.",
    grantsOverTime: "Subventions de la Fondation au Fil du Temps",
    year: "Année",
    totalAwarded: "Total des Subventions Accordées (USD)",
    trend: "Tendance",
    interpretation: "Interprétation",
    highInvestment: "Année de fort investissement",
    consolidation: "Phase de consolidation",
    focusOnImpact: "Focus sur l'impact plutôt que le volume",
    threeYearTotal: "Total sur 3 Ans: 405 000$ investis dans les initiatives des membres JCI",
    whatGrantsFund: "Ce que Financent les Subventions (2024-2025)",
    programsCompetitions: "Compétitions de Programmes JCI",
    leadershipAcademies: "Académies et Sommets de Leadership",
    entrepreneurshipSupport: "Soutien à l'Entrepreneuriat et aux Affaires",
    infrastructureSupport: "Secrétariat Physique et Infrastructure",
    growthInitiatives: "Initiatives de Croissance et de Développement",
    regionalAllocation: "Allocation Régionale",
    successStories: "Histoires de Succès des Subventions",
    grantCycle: "Processus du Cycle de Subventions",
    ctaTitle: "Financez Votre Initiative JCI",
    viewOpportunities: "Voir les Opportunités de Subventions",
    checkQualify: "Vérifiez Si Vous Êtes Éligible",
    submitProposal: "Soumettre une Proposition",
    sourceNote: "Source: Rapport Annuel de la Fondation JCI 2025"
  },
  jciSenate: {
    title: "Reconnaissance du Sénat JCI",
    headline: "84 375 Leaders à Vie: Le Sénat JCI",
    heroDescription: "Le Sénat JCI est plus qu'un honneur—c'est une adhésion à vie à une communauté mondiale de leaders exceptionnels.",
    totalSenators: "Total des Sénateurs Actifs",
    allTime: "De Tous les Temps",
    newSenators: "Sénateurs Honorés en 2025",
    newSelections: "nouvelles sélections",
    annualGrowth: "Taux de Croissance Annuel",
    sustainableGrowth: "durable, axé sur la qualité",
    lifetimeValue: "Valeur à Vie",
    unlimitedMentorship: "Mentorat, réseautage et engagement illimités",
    demographicsDashboard: "Démographie des Sénateurs",
    ageProfile: "Profil d'Âge",
    genderComposition: "Composition par Genre",
    male: "Masculin",
    female: "Féminin",
    professionalBackground: "Formation Professionnelle",
    corporateExecutives: "Cadres d'Entreprise",
    entrepreneursOwners: "Entrepreneurs/Propriétaires d'Entreprise",
    educatorsTrainers: "Éducateurs et Formateurs",
    governmentPublic: "Gouvernement et Secteur Public",
    nonprofitSocial: "Sans But Lucratif et Social",
    otherFields: "Autres Domaines Professionnels",
    valueProposition: "Proposition de Valeur du Sénat",
    engagementTiers: "Modèle d'Engagement du Sénat",
    tier1: "Niveau 1: Mentorat",
    tier2: "Niveau 2: Leadership de Programme",
    tier3: "Niveau 3: Leadership Organisationnel",
    tier4: "Niveau 4: Héritage et Plaidoyer",
    successMetrics: "Métriques de Succès du Sénat",
    ctaTitle: "Rejoignez le Sénat JCI",
    understandPath: "Comprendre le Chemin vers le Sénat",
    exploreBenefits: "Explorer les Avantages du Sénateur",
    becomeMentor: "Devenir Mentor",
    nominateLeaders: "Nominer des Leaders Exceptionnels",
    sourceNote: "Source: Registre du Sénat JCI 2025"
  }
} as const;
